module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promotion-netflix",
    class: {
      'en-style': _vm.language === 'en'
    }
  }, [_c('div', {
    staticClass: "container-top"
  }, [_c('plex-header', {
    staticStyle: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-wrap container"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('banner_title')))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left-wrap"
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('banner_des')) + "\n              ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('banner_btn')))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('img', {
    staticClass: "right-img",
    attrs: {
      "src": require("../../../../static/img/promotion/bbc-right.png"),
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bbcInfo-wrap"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('bbcInfo_title')))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('bbcInfo_des')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "benefit-wrap"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('benefit_title')))]), _vm._v(" "), _c('div', {
    staticClass: "benefit"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box "
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/bbc-benefit1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('benefit_item1')) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/bbc-benefit2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('benefit_item2')) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/bbc-benefit3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('benefit_item3')) + "\n                  ")])])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadPlex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "simple-steps pc-show"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('steps_title')))]), _vm._v(" "), _c('div', {
    staticClass: "steps-item"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "step-icon",
    attrs: {
      "src": require("../../../../static/img/promotion/step-icon1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "step-img",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-step1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('steps_item1')))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "step-icon",
    attrs: {
      "src": require("../../../../static/img/promotion/step-icon2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "step-img",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-step2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('steps_item2')))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "step-icon",
    attrs: {
      "src": require("../../../../static/img/promotion/step-icon3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "step-img",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-step3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('steps_item3')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadPlex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "simple-steps phone-show"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('steps_title')))]), _vm._v(" "), _c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "steps-text"
  }, [_c('img', {
    staticClass: "step-img",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-step1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('steps_item1')))])]), _vm._v(" "), _c('div', {
    staticClass: "steps-text"
  }, [_c('img', {
    staticClass: "step-img",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-step2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('steps_item2')))])]), _vm._v(" "), _c('div', {
    staticClass: "steps-text"
  }, [_c('img', {
    staticClass: "step-img",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-step3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('steps_item3')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('getPlex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "reviews"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('review_title')))]), _vm._v(" "), _c('div', {
    staticClass: "carousel"
  }, [_c('review-text')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "features"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('feature_title')))]), _vm._v(" "), _c('div', {
    staticClass: "ftu-text1"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title1')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con1')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title2')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con2')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title3')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con3')))])])]), _vm._v(" "), _c('div', {
    staticClass: "ftu-text2"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title4')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con4')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title5')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con5')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('features_title6')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('features_con6')))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('getPlex')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "faqs"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('faqs_title')))]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('faqs_title1')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('faqs_con1')))]), _vm._v(" "), _c('div', {
    staticClass: "attach-box"
  }, [_c('div', {
    staticClass: "attach1"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('faqs_des1')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "attach2"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/bbc-faq-error.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('faqs_des2')) + "\n              ")])])])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('faqs_title2')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('faqs_con2')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('faqs_title3')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('faqs_con3')))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('faqs_title4')))]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('faqs_con4')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.language === 'zh') ? _c('img', {
    staticClass: "footer-icon",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-footer-icon.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.language === 'en') ? _c('img', {
    staticClass: "footer-icon",
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-footer-icon-en.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('footer_con1')))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('router-link', {
    staticClass: "down-btn",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t('downloadPlex')))])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/bbc-right.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/bbc-img.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "star-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/img/promotion/netflix-star.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cd10bbf6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/promotion/Bbc/Bbc.vue
// module id = 1390
// module chunks = 1